import _regeneratorRuntime from "/home/runner/work/intro-3d-main/intro-3d-main/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(rootSaga);
export default function rootSaga() { return _regeneratorRuntime().wrap(function rootSaga$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
        case "end": return _context.stop();
    } }, _marked); }
